import { Directive, ElementRef, Input } from '@angular/core';

const classlist = [
	'rounded-md',
	'bg-white',
	'w-full',
	'mx-auto',
	'font-medium',
	'text-vqblue',
	'border-vqblue',
	'vertical-align',
	'flex',
	'items-center',
	'justify-center',
	'shadow',
	'disabled:opacity-50',
	'disabled:bg-gray-100',
	'drop-shadow',
	'mat-ripple',
];

const dangerClasslist = [
	'rounded-md',
	'bg-white',
	'w-full',
	'mx-auto',
	'text-red-500',
	'font-medium',
	'vertical-align',
	'flex',
	'items-center',
	'border-vqred',
	'justify-center',
	'shadow',
	'disabled:opacity-50',
	'disabled:bg-gray-100',
	'drop-shadow',
	'mat-ripple',
];

const secondaryClasslist = [
	'rounded-md',
	'w-full',
	'mx-auto',
	'font-medium',
	'vertical-align',
	'flex',
	'items-center',
	'justify-center',
	'shadow',
	'ring-1',
	'ring-inset',
	'ring-gray-300',
	'disabled:opacity-50',
	'disabled:bg-gray-100',
	'drop-shadow',
	'bg-blue-50',
	'text-gray-800',
	'border-blue-500',
	'mat-ripple',
];

const xs = `text-xs my-3.5 py-1 px-2`;
const sm = `text-sm my-3.5 px-2 py-1`;
const md = `text-base my-3.5 px-2.5 py-1.5`;
const lg = `my-3.5 px-3 py-3 text-base`;
const xl = `my-3.5 px-6 py-5 text-base`;

const link =
	'px-3 py-3 text-sm w-full mx-auto font-medium text-vqblue  vertical-align flex items-center justify-center font-semibold hover:shadow-sm hover:ring-1 ring-inset ring-gray-300  disabled:opacity-50 disabled:bg-gray-100';
const buttonTypes = {
	xs,
	sm,
	md,
	lg,
	xl,
	link,
};
type ControlType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'link';
@Directive({
	selector: '[vQbutton]',
})
export class ButtonTypeDirective {
	private className: ControlType = 'lg';
	@Input() set vQbutton(value: ControlType) {
		this.className = value ? value : this.className;
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - contructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private el: ElementRef) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit() {
		let classes = '';
		if (this.el.nativeElement.className.includes('btn-red')) {
			classes = `${dangerClasslist.join(' ')} ${buttonTypes[this.className]}`;
			this.el.nativeElement.className = classes;
			return;
		}
		if (this.el.nativeElement.className.includes('btn-gray')) {
			classes = `${secondaryClasslist.join(' ')} ${buttonTypes[this.className]}`;
			this.el.nativeElement.className = classes;
			return;
		}
		classes = `${classlist.join(' ')} ${buttonTypes[this.className]}`; //${this.el.nativeElement.className}
		this.el.nativeElement.className = classes;
	}
}
